module.exports = __webpack_public_path__ + "images/bannerIT-dbe18faec126bf1ea8b41e01591d83b3.jpg";